import { Component, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import { EventService, RoutingService, GlobalMessageService, TranslationService, GlobalMessageType } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { KbCartService } from 'src/app/services/feature/cart/kb-cart.service';

@Component({
  selector: 'app-kb-save-cart-dialog',
  templateUrl: './kb-save-cart-dialog.component.html',
  styleUrls: ['./kb-save-cart-dialog.component.scss'],
  standalone: false
})
export class KbSaveCartDialogComponent extends SavedCartFormDialogComponent {
  showExistingCartFlow: boolean = false;
  selectedOption: any = '';
  showExistingCartoption: boolean = false;
  savedCartList: any;
  selectedSavedCartName: any = '';
  override descriptionMaxLength: number = 255;
  private destroy$ = new Subject<void>();
  constructor(launchDialogService: LaunchDialogService,
    el: ElementRef,
    savedCartService: SavedCartFacade,
    eventService: EventService,
    routingService: RoutingService,
    globalMessageService: GlobalMessageService,
    private kbCartService: KbCartService,
    public route: Router,
    public translationService: TranslationService,
    private cartTrackingService: CartTrackingService,) {
    super(launchDialogService, el, savedCartService, eventService, routingService, globalMessageService)
    this.launchDialogService.data$.pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (data.data.length > 0) {
          this.savedCartList = data.data;
          this.showExistingCartFlow = true;
        }
      }
    )
  }

  nextClick() {
    if (this.selectedOption == 'new') {
      this.showExistingCartFlow = false;
    } else if (this.selectedOption == 'existing') {
      this.showExistingCartoption = true;
    }
  }
  onItemChange(e) {
    this.selectedOption = e.target.value;
  }

  save(cartId) {
    const payload = {
      saveCartName: this.selectedSavedCartName.name,
      cartId: this.selectedSavedCartName.code
    }
    this.kbCartService.saveExistingCart(payload, cartId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      let msgkey = '';
      this.translationService.translate(res?.['message'].message).pipe(takeUntil(this.destroy$)).subscribe((key) => {
        if (key.includes('{0}')) {
          msgkey = key.replace('{0}', res.savedCartData.name);
        }
      });
      this.kbCartService.saveCartMsg.next(msgkey);
      this.route.navigate(["saved-carts", res.savedCartData.code]);
      this.cartTrackingService.trackEditCart(res.savedCartData.code, res.savedCartData.name, this.savedCartList.cart?.currentB2BUnit?.uid);
      const data = {
        message: res.message,
        reason: 'new cart save'
      }
      this.launchDialogService.closeDialog(data);
    })
  }

  saveNewCart(cartId) {
    if (this.form.valid) {
      const payload = {
        saveCartDescription: this.form.controls['description'].value,
        saveCartName: this.form.controls['name'].value
      }
      this.kbCartService.saveNewCart(payload, cartId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        if (res.message.status === 'SUCCESS') {

          let msgkey = '';
          this.translationService.translate(res?.['message'].message).pipe(takeUntil(this.destroy$)).subscribe((key) => {
            if (key.includes('{0}')) {
              msgkey = key.replace('{0}', res.savedCartData.name);
            }
          });
          this.kbCartService.saveCartMsg.next(msgkey);
          this.cartTrackingService.trackSaveCart(res.savedCartData.code, res.savedCartData.name, this.savedCartList.cart?.currentB2BUnit?.uid);
          this.route.navigate(["saved-carts", res.savedCartData.code]);
          const data = {
            message: res.message,
            reason: 'new cart save'
          }
          this.launchDialogService.closeDialog(data);
        }

      })
    }
  }

  setSelectedSavedCart(ev, item) {
    this.selectedSavedCartName = item;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    // Unsubscribe from the scroll event
    this.destroy$.next();
    this.destroy$.complete();
  }

}
